import React from 'react'
import {
  StyledVariable,
  UrgencyHandler,
  LINK_KEY,
  OFFER_TERMS_VARIABLE_NAME,
  TEXT_KEY,
  type UrgencyEntries,
} from '@mc/feature-variables'
import { PERSONA_PROMO_FEATURE_FLAG } from '../../constants'

const getUrgencyConfig = (textKey?: string) =>
  ({
    link: {
      variableName: OFFER_TERMS_VARIABLE_NAME,
      variableKey: LINK_KEY,
    },
    text: {
      variableName: OFFER_TERMS_VARIABLE_NAME,
      variableKey: textKey || TEXT_KEY,
    },
  }) as UrgencyEntries

export const PersonaPromoTermsLink = ({
  children,
  textKey,
  className = '',
}: {
  children?: React.ReactNode
  textKey?: string
  className?: string
}) => (
  <UrgencyHandler
    flagName={PERSONA_PROMO_FEATURE_FLAG}
    config={getUrgencyConfig(textKey)}
    trackEV={true}
  >
    {({ link, text }) => (
      <a
        className={`mc-text--link ${className}`}
        href={link as string}
        target='_blank'
        rel='noreferrer'
      >
        {children || <StyledVariable text={text} />}
      </a>
    )}
  </UrgencyHandler>
)
